// extracted by mini-css-extract-plugin
export var actionButton = "_9e-0";
export var attachmentLine = "_9e-1";
export var fileInput = "_9e-2";
export var fileUploadWrapper = "_9e-4";
export var footer = "_9e-3";
export var modalContent = "_9e-5";
export var paperclip = "_9e-6";
export var quillEditor = "_9e-7";